import ModuleWrapper from 'shared-lib/containers/Module';

const TrafficSplitter  = () => import(/* webpackChunkName: "trafficsplitter-default" */ '@/views/trafficSplitter/TrafficSplitter');
const TrafficSplitterDetails  = () => import(/* webpackChunkName: "trafficsplitter-details" */ '@/views/trafficSplitter/TrafficSplitterDetails');
const AddTrafficSplitter     = () => import(/* webpackChunkName: "trafficsplitter-form" */ '@/views/trafficSplitter/AddTrafficSplitter');
const EditTrafficSplitter     = () => import(/* webpackChunkName: "trafficsplitter-form" */ '@/views/trafficSplitter/EditTrafficSplitter');
const meta = (data = {}) => ({
    privilegeModule: 'smart_links',
    title: 'Smart Links',
    auth: true,
    ...data,
});

export default [{
    path: 'smart-links',
    component: ModuleWrapper,
    meta: meta({
        permission: 'read',
    }),
    children: [
        {
            path: '',
            name: 'Smart Links',
            component: TrafficSplitter,
            meta: meta({
                permission: 'read',
            }),
        },
        {
            path: ':splitterId(\\d+)/clone',
            name: 'CloneTrafficSplitter',
            component: EditTrafficSplitter,
            props: true,
            meta: meta({
                permission: 'write',
            }),
        },
        {
            path: ':splitterId(\\d+)/edit',
            name: 'EditTrafficSplitter',
            component: EditTrafficSplitter,
            props: route => ({
                ...route.params,
                isEdit: true,
            }),
            meta: meta({
                permission: 'write',
            }),
        },
        {
            path: 'add',
            name: 'AddTrafficSplitter',
            component: AddTrafficSplitter,
            props: true,
            meta: meta({
                permission: 'write',
            }),
        },
        {
            path: ':splitterId(\\d+)',
            name: 'TrafficSplitterDetails',
            component: TrafficSplitterDetails,
            props: true,
            meta: meta({
                permission: 'read',
            }),
        },
    ],
}];
